import { useMemo } from 'react';
import { useSymptomPriorities } from './useSymptomPriorities';
import _ from 'lodash';
export function useSymptomPrioritiesById() {
    const symptomPriorities = useSymptomPriorities();
    return useMemo(() => _.mapValues(_.groupBy(symptomPriorities, 'id'), _.first), [symptomPriorities]);
}
